/** Last 5 chars of collection number for B/L display (supports alphanumeric). */
export function formatHblBlNo(collectionNo) {
  const raw = String(collectionNo || '').trim();
  if (!raw) return '—';
  const digits = raw.replace(/\D/g, '');
  if (digits.length >= 5) return digits.padStart(5, '0').slice(-5);
  const alnum = raw.replace(/[^0-9a-zA-Z]/g, '');
  if (alnum.length >= 5) return alnum.slice(-5).toUpperCase();
  return (alnum || raw).padStart(5, '0').toUpperCase().slice(-5);
}
